<template>
  <div class="slideCode" v-if="showCode&&bannerData[17]&&bannerData[17].list.length>0">
    <div
      class="draggable-image"
      :class="{ 'dragging': isDragging }"
      @mousedown="startDrag"
      @mouseup="endDrag"
      @mousemove="doDrag"
      @mouseout="setTimer();"
      :style="{ left: x + 'px', top: y + 'px' }"
    >
      <p class="close">
        <img @click="closeCode"  src="http://hfy-img.xzyunchuang.com/fc2822624395c616a5adcdbefc67182f" />
      </p>
      <img class="imgB" @click="goRouter(bannerData[17].list[0])" :src="bannerData[17].list[0].url">
    </div>
  </div>
</template>
 
<script>
export default {
  props:{
    bannerData: {
      type: [Object,Array],
      default:[]
    }
  },
  data() {
    return {
      showCode:true,
      screenWidth:null,
      screenHeight:null,
      timer:null,
      rights:true,
      bottoms:true,
      isDragging: false,
      x: 0,
      y: 0,
      initialX: 0,
      initialY: 0,
      offsetX: 0,
      offsetY: 0
    };
  },
  mounted(){
    this.setTimer();
    this.screenWidth = document.documentElement.clientWidth;
    this.screenHeight= document.documentElement.clientHeight;
    
    window.onresize = () => {
      return (() => {
      this.screenWidth = document.documentElement.clientWidth;
      this.screenHeight= document.documentElement.clientHeight;
      })()
    }
  },
  methods: {
    closeCode(){
      this.showCode=false;
      clearInterval(this.timer);
    },
    goRouter(item){
      if(item.type==1&&item.relateId&&(item.relateId!=null)){
        window.open(item.relateId,"_blank")
      }
      else if(item.type==2){
        window.open('/newsDetail?DetailId=' + item.relateId, "_blank");
      }
      else if(item.type==3){
         if(index){
           window.open('/spacilPage1', "_blank");
           return;
         }
         if (item.module) {
                window.open('/topList?topic=' + item.relateId, "_blank");
            } else {
                window.open('/topList1?topic=' + JSON.stringify({topic:item.relateId}), "_blank");
            }
      }
    },
    setTimer(){
      var that =this;
      if(!this.timer){

      this.timer=setInterval(function(){
        if(that.rights){
          that.x=that.x+0.5;
        }else{
          that.x=that.x-0.5;
        }
        if(that.bottoms){
          ++that.y;
        }else{
          --that.y;
        }
        if(that.x<=0&& (!that.right)){
          that.rights =true;
        }
        if((that.x+190)>that.screenWidth){
          that.rights =false;
        }
        if(that.y<=0&& (!that.bottom)){
          that.bottoms =true;
        }
        if(((that.y+190)>that.screenHeight)){
          that.bottoms =false;
        }
      },20)
    }
    },
    startDrag(event) {
      this.isDragging = true;
      this.initialX = event.clientX - this.x;
      this.initialY = event.clientY - this.y;
    },
    doDrag(event) {
      clearInterval(this.timer);
      this.timer=null;
      if (this.isDragging) {
        this.offsetX = event.clientX - this.initialX;
        this.offsetY = event.clientY - this.initialY;
        this.x = this.offsetX;
        this.y = this.offsetY;
      }
    
    },
    endDrag() {
      this.isDragging = false;
    }
  }
};
</script>
 
<style lang="scss" scoped>
.slideCode{
}
.draggable-image {
  padding:0 2px 2px 2px;
  background: #fff;
  border-radius: 2px;
  z-index: 10000;
  position: fixed;
  cursor: move;
  user-select: none;
  .close{
    text-align: right;
    img{
      position: relative;
      right:10px;
      top:8px;
      // left: 4px;
      // bottom: 2px;
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }
  .imgB{
    width: 180px;
    height: 180px;
  }
}
.dragging {
  cursor: grabbing;
}
</style>


// WEBPACK FOOTER //
// src/views/index/slideCode.vue